<template>
  <vs-card-group class="remove-scroll" w="12">
    <div v-for="episode in episodes" :key="episode.id">
      <vs-card @click="!(episode.show_url && episode.season_number) ? goToLink(`https://videnti.co/watch/${seriesUrl}/${seasonNumber}/${episode.episode_number}`) : goToLink(`https://videnti.co/watch/${episode.show_url}/${episode.season_number}/${episode.episode_number}`)">
        <template #title>
          <div class="title-container">
            <h3 class="episode-name-cut animate" @mouseover="checkElementAnimation">{{episode.name}}</h3>
          </div>
        </template>
        <template #img>
          <img v-if="episode.thumbnail != null || episode.thumbnail === ''" :src="episode.thumbnail" alt="" @error="imageUrlAlt" width="1080px"><img v-else :src="`https://i.imgur.com/Zx6wTMp.png`" alt="" @error="imageUrlAlt" width="1080px">
          <progress v-if="episode.seenStatus === 2"
                    :aria-valuemax="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                    :max="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                    :aria-valuenow="(episode.durationStatus === undefined) ? 0 : getSecondsFromISO(episode.durationStatus)"
                    :value="(episode.durationStatus === undefined) ? 0 : getSecondsFromISO(episode.durationStatus)"
          ></progress>
          <progress v-if="episode.seenStatus === 1"
                    :aria-valuemax="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                    :max="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                    :aria-valuenow="episode.seconds + episode.minutes*60 + episode.hours*60*60 + 1"
                    :value="episode.seconds + episode.minutes*60 + episode.hours*60*60 + 1"
          ></progress>
        </template>
        <template #text>
          <p>
            {{ episode.hours ? episode.hours + ":" : "" }}{{ (episode.minutes && episode.minutes !== 0) && (episode.seconds && episode.seconds !== 0 ) ? episode.minutes.zeroPad() + ":" + episode.seconds.zeroPad() + " ·" : "" }} {{ getVideoType(episode.type) }} {{ episode.released ? "· Estrenado el " + $luxonDateTime.fromISO(episode.released).toLocaleString($luxonDateTime.DATE_SHORT) : "" }}
          </p>
        </template>
        <template #interactions>
          <vs-button v-if="seriesName || episode.show_name" class="btn-chat" shadow style="background: #195bff !important;" @click.stop="openShowInfo ? openShowInfo(null, episode.show_name, episode.show_url) : goToLink(`https://videnti.co/watch/${seriesUrl}`)">
            <span class="span"> {{seriesName ? seriesName : episode.show_name}} </span>
          </vs-button>
          <vs-button class="btn-chat" shadow style=""> <!-- background: rgba(var(--vs-text), 1); color: rgba(var(--vs-background), 1); -->
            <span v-if="episode.episode_number_custom">{{ episode.episode_number_custom }}</span>
            <span v-else-if="showSeasonNumber">T{{seasonNumber ? seasonNumber : episode.season_number}}E{{episode.episode_number}}</span>
            <span class="span" v-else>{{ $t("general.episode_no", { episode: episode.episode_number }) }}</span>
          </vs-button>
        </template>
      </vs-card>
    </div>
  </vs-card-group>
</template>

<script>
import {getVideoType} from "../utils/helpers";

export default {
  name: "EpisodesCardsSingleSeason",
  props: ['episodes', 'seriesUrl', 'seriesName', 'seasonNumber', 'showSeasonNumber', 'openShowInfo'],
  methods: {
    getVideoType,
    imageUrlAlt(event) {
      event.target.src = "https://i.imgur.com/Zx6wTMp.png"
    },
    goToEpisode(temporada, episodio) {
      if (window.location.pathname.endsWith("/")) {
        window.location = window.location.origin + window.location.pathname + temporada + "/" + episodio;
      } else {
        window.location = window.location.origin + window.location.pathname + "/" + temporada + "/" + episodio;
      }
    },
    goToLink(link, blank) {
      if (blank) {
        window.open(link);
      } else {
        window.location = link;
      }
    },
    checkElementAnimation: function (e) {
      const element = e.target;
      if (element.clientWidth <= element.parentElement.clientWidth) {
        element.classList.remove("animate");
      }
      /* console.log("Element CLIENTWIDTH: " + element.clientWidth);
      console.log("Parent CLIENTWIDTH: " + element.parentElement.clientWidth); */
    }
  }
}
</script>

<style scoped>
.title-container {
  white-space: nowrap;
  position: relative;
  border-radius: 5px;
  width: 100%;
  overflow: hidden;
}

.title-container .episode-name-cut {
  display: block;
}

.title-container:hover {
  overflow: hidden;
}

.title-container .animate {
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-container .animate:hover {
  display: inline-block;
  overflow: visible;
  text-overflow: clip;
  position: relative;
  animation: LeftRight 5s infinite alternate ease-in-out;
}

/* .episode-name-cut {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
} */

/* height: 1.2em; ^^ */
progress {
  appearance: none;
  position: absolute;
  width: 100%;
  height: 0.5rem;
  bottom: 0;
  left: 0;
  overflow: hidden;
  color: rgb(var(--vs-primary));
}

progress::-webkit-progress-value { background-color: rgb(var(--vs-primary)); }
</style>

<style>
@keyframes LeftRight {
  0%, 20% {
    transform: translateX(0%);
    left: 0;
  }
  80%, 100% {
    transform: translateX(-101%);
    left: 100%;
  }
}
</style>
